<template>
  <div />
</template>

<script setup>
const route = useRoute();

navigateTo(useAuthStore().isLoggedIn
  ? {
    path: '/events',
    query: route.query, // pass query params (especially for stripe ?payment_response=)
  }
  : '/login');
</script>
